var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(159 382)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2032",
    "data-name": "Group 2032",
    transform: "translate(-230 -524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    transform: "translate(230 524)",
    fill: "#fff",
    stroke: "#d4dbe2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    transform: "translate(75 146)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(170.051 392.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M14.858,20.166,21.024,14l7.77,6.906",
    transform: "translate(-1.895 -1.504)",
    fill: "none",
    stroke: "#d4dbe3",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M1,23.906,8.77,17l7.339,6.258",
    transform: "translate(0 -1.914)",
    fill: "none",
    stroke: "#d4dbe3",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1830",
    "data-name": "Rectangle 1830",
    width: 26,
    height: 22,
    rx: 3,
    transform: "translate(0.949 3.223)",
    fill: "none",
    stroke: "#d4dbe3",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(10.949 7.223)",
    fill: "none",
    stroke: "#d4dbe3",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyAvatar);
export default __webpack_public_path__ + "static/media/company_avatar.13d59d077f1af466e04b776a68d82cbe.svg";
export { ForwardRef as ReactComponent };